import { WfnCurrencyBox } from '@adp-wfn/mdf-wc-react';
import React from 'react';
import { BaseField } from './BaseField';
import { Field } from './types';

/**
 * Currency input field component with min/max validation
 * @param props - Field component props
 * @param props.data - Field configuration with value, min, max, and currency code
 * @param props.onChange - Callback function for value changes
 * @returns JSX element for currency input field
 */
export function Currency({ data, onChange }: Field) {
  return (
    <BaseField>
      <WfnCurrencyBox
        label={data.label}
        max={data.max}
        min={data.min}
        required={data.required}
        value={data.value}
        onSdfChange={(event) => onChange(event.detail)}
      />
    </BaseField>
  );
}
